var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('p',[_vm._v("※")]),_c('p',[_vm._v("이미지를 클릭 하시면 더 크게 보실 수 있습니다.")])])}]

export { render, staticRenderFns }